import React, { ReactNode } from "react";
import Header from "./header";
import Footer from "./footer";
import { Box } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
// import { animateScroll as scroll } from "react-scroll";

type Props = { children: ReactNode };

const Layout = ({ children }: any) => {
  const location = useLocation();
  const currentUrl = location.pathname;
  
  return (
    <Box>
      {
        currentUrl !== "/ai/design" && currentUrl !== "/ai/smroom" && <Header />
      }
      
      <Box>
        {children}
      </Box>
      {
        currentUrl === "/" && <Footer />
      }
      
    </Box>
  );
};

export default Layout;
